export const ROUTE_LAYOUTS = Object.freeze({
    PUBLIC: "public",
    SHELL: "shell",
    FULLSCREEN: "fullscreen",
    MOBILE: "mobile",
});

export const PERMISSION_MATCH = Object.freeze({
    ALL: "all",
    ANY: "any",
});

function normalizePermission(permission, matchMode) {
    if (!permission) {
        return {
            permission: null,
            matchMode: PERMISSION_MATCH.ALL,
        };
    }

    return {
        permission,
        matchMode: matchMode || (Array.isArray(permission) ? PERMISSION_MATCH.ANY : PERMISSION_MATCH.ALL),
    };
}

export function createSection(config) {
    return {
        order: 0,
        icon: null,
        iconKey: null,
        ...config,
    };
}

export function createAppRoute(config) {
    const routeAccess = normalizePermission(config.routePermission ?? config.permission, config.routePermissionMatch ?? config.permissionMatch);
    const menuAccess = normalizePermission(
        config.menu === false ? null : config.menuPermission ?? routeAccess.permission,
        config.menuPermissionMatch ?? routeAccess.matchMode,
    );
    const menuKey = config.menuKey || config.key;
    const hasExplicitActiveMenuKey = Object.prototype.hasOwnProperty.call(config, "activeMenuKey");
    const hasExplicitActiveSectionKey = Object.prototype.hasOwnProperty.call(config, "activeSectionKey");

    return {
        key: config.key,
        path: config.path,
        pageLabel: config.pageLabel || config.label || config.menuLabel || "",
        element: config.element,
        frontend: config.frontend || "old",
        layout: config.layout || ROUTE_LAYOUTS.SHELL,
        requiresAuth: config.requiresAuth !== false,
        routePermission: routeAccess.permission,
        routePermissionMatch: routeAccess.matchMode,
        matchPatterns: config.matchPatterns || [config.path],
        activeMenuKey: hasExplicitActiveMenuKey ? config.activeMenuKey : config.menu === false ? null : menuKey,
        activeSectionKey: hasExplicitActiveSectionKey ? config.activeSectionKey : config.sectionKey || null,
        menu:
            config.menu === false
                ? null
                : {
                      key: menuKey,
                      sectionKey: config.sectionKey,
                      label: config.menuLabel || config.label,
                      icon: config.menuIcon || null,
                      iconKey: config.menuIconKey || null,
                      order: config.menuOrder || 0,
                      navigatePath: config.navigatePath || config.path,
                      openInNewTab: config.openInNewTab === true,
                      badgeKey: config.badgeKey || null,
                      badgeTooltipKey: config.badgeTooltipKey || null,
                      permission: menuAccess.permission,
                      permissionMatch: menuAccess.matchMode,
                  },
    };
}

export function buildSectionFromData(data) {
    return createSection(data);
}

export function buildRouteFromData(data, options = {}) {
    const routeRuntimeOverrides = options.routeRuntimeOverrides?.[data.key] || {};
    const routeElementMap = options.routeElementMap || {};
    const activeSectionKeyByMenuKey = options.activeSectionKeyByMenuKey || {};
    const hasActiveSectionOverride = Object.prototype.hasOwnProperty.call(routeRuntimeOverrides, "activeSectionKey");
    const derivedActiveSectionKey = data.activeMenuKey ? activeSectionKeyByMenuKey[data.activeMenuKey] : undefined;
    const routeConfig = {
        ...data,
        element: routeElementMap[data.key] ?? null,
        ...routeRuntimeOverrides,
    };

    if (hasActiveSectionOverride) {
        routeConfig.activeSectionKey = routeRuntimeOverrides.activeSectionKey;
    } else if (data.activeSectionKey !== undefined) {
        routeConfig.activeSectionKey = data.activeSectionKey;
    } else if (derivedActiveSectionKey !== undefined) {
        routeConfig.activeSectionKey = derivedActiveSectionKey;
    }

    return createAppRoute(routeConfig);
}
